module.exports = __webpack_public_path__ + "app/assets/images/loading-81453d27bc56443373e9332f1ba2a7bd.gif";